import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {AppDataService, ConfigService, DeliveryOrderService, XpressPaymentTransactionService} from 'app/services';
import {Utils} from 'app/utils';
import {StylesStatus} from 'app/models/users/StylesStatus';
import moment from 'moment/moment';
import {
	FieldTypeEnum,
	FilterTransactionStatusEnum,
	MenuPermissionActionEnum,
	MenuPermissionConfig,
	RiderVehicleType
} from 'app/models';
import {UserTableSettingsService} from 'app/services/user-table-settings.service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import {AppComponent} from 'app/app.component';
import {FinanceMenuEnum} from 'app/finance';
import {TransactionTypeEnum} from 'app/models/transaction/transaction-type.enum';
import {TransactionsTableHeaders} from 'app/home/home-transactions/transactions-table-headers';
import {RiderTag} from 'app/models/rider/rider-tag.model';
import {TransactionTypeModel} from 'app/models/transaction/transaction-type.model';
import {FinanceCardEnum} from 'app/models/transaction/finance-card.enum';
import {ExportFileTypeModel} from 'app/models';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import {TableLazyLoadEvent} from 'primeng/table';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
	selector: 'home-transactions',
	templateUrl: './home-transactions.component.html',
	styleUrls: ['./home-transactions.component.scss',
		'../../../../styles/paginator.scss'],
	providers: [MessageService]
})
export class HomeTransactionsComponent implements OnInit, AfterViewInit {
	@Input()
	public menuPermissionActive!: string;

	@Output() changedVisibleExportSidebarEmit = new EventEmitter<boolean>();

	changedVisibleExportSidebar(increased: any) {
		this.changedVisibleExportSidebarEmit.emit(increased);
	}

	@ViewChild(ColumnSelectorComponent)
	public columnSelector!: ColumnSelectorComponent;

	showDetailTransactionSidebar: boolean = false;
	showExportSidebar: boolean = false;
	filterButtonVisible: boolean = true;
	selectedTransaction: any;
	arrayFilterServiceTypes = RiderVehicleType.RiderVehicleTypeXpressAndBoracayList;
	arrayFilterRiderTags = RiderTag.RiderTagList;
	arrayFilterTransactionTypes = TransactionTypeModel.TransactionTypeList;
	topUpsTXtypes = [
		TransactionTypeEnum.CustomerTip,
		TransactionTypeEnum.RiderEarning,
		TransactionTypeEnum.TopUpWallet,
		TransactionTypeEnum.WaitingFeeRiderEarning,
		TransactionTypeEnum.CancellationFeeRiderEarning,
		TransactionTypeEnum.ReferralEarning,
		TransactionTypeEnum.PrizeMoney,
		TransactionTypeEnum.CashRiderEarning,
		TransactionTypeEnum.XpressIncentive,
		TransactionTypeEnum.TopUpFromPaymentCard,
		TransactionTypeEnum.AdjustWalletBalance,
		TransactionTypeEnum.OnlineTimeIncentive,
		TransactionTypeEnum.CebuanaTopUpCallback,
	];
	topUpsTransactionTypes = [{
		name: 'All',
		value: 0
	}].concat(TransactionTypeModel.TransactionTypeList.filter(x => this.topUpsTXtypes.includes(x.value)));

	arrayFilterPaymentMethodTypes: any = [];
	arrayFilterStatuses: any = [{
		name: 'All', value: 0
	}, {
		name: 'Completed', value: FilterTransactionStatusEnum.Completed
	}, {
		name: 'Pending', value: FilterTransactionStatusEnum.Pending
	}, {
		name: 'Cancelled', value: FilterTransactionStatusEnum.Cancelled
	}];

	menuTabItems: MenuItem[] = [
		{
			label: 'Collection',
			command: (e: any) => {
				this.assignFinanceMenu(FinanceMenuEnum.Collection);
			}
		}
	];
	activeTabItem!: MenuItem;

	tableHeader = '';
	tableDataHeader = '';
	activeCard!: FinanceCardEnum;

	exportData: any = {};
	fileName = '';
	transactions: Array<any> = [];
	cols: Array<any> = [];
	defaultCols: Array<any> = [];
	revenueAmounts: FinanceCardsAmounts = new FinanceCardsAmounts();

	revenueCols = [
		{
			field: 'BookingId', header: 'Booking ID', width: '20%', fieldType: FieldTypeEnum.Inputs,
			model: 'bookingId', placeholder: 'Type here', active: false
		},
		{
			field: 'TransactionId', header: 'TX ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
			model: 'transactionId', placeholder: 'Type here', active: false
		},
		{
			field: 'CreatedAtDate',
			header: 'TX Date',
			width: '20%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'createdAtDate',
			placeholder: 'Date',
			active: false
		},
		{
			field: 'CreatedAtTime',
			header: 'TX Time',
			width: '20%',
			fieldType: FieldTypeEnum.CalendarTime,
			model: 'createdAtTime',
			placeholder: 'Time',
			active: false
		},
		{
			field: 'RiderId', header: 'Driver ID', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
			placeholder: 'Type here', active: false
		},
		{
			field: 'DriverTags',
			header: 'Driver Tag',
			width: '20%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'driverTags',
			options: this.arrayFilterRiderTags,
			placeholder: 'Select',
			active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'DiscountType', header: 'Discount Type', width: '20%', fieldType: FieldTypeEnum.Inputs,
			model: 'discountType', placeholder: 'Type here', active: false
		},
		{
			field: 'VehicleTypeText',
			header: 'Ride Type',
			width: '20%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'vehicleType',
			options: this.arrayFilterServiceTypes,
			placeholder: 'Select',
			active: false
		},
		{
			field: 'BaseFare',
			header: 'Base Fare',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'baseFare',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'Distance',
			header: 'Distance',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'distance',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'Time', header: 'Time', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'time',
			placeholder: 'Type here', active: false
		},
		{
			field: 'Surge', header: 'Surge', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'surge',
			placeholder: 'Type here', active: false
		},
		{
			field: 'BookingFeeAmount',
			header: 'Booking Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'bookingFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CancellationFeeAmount',
			header: 'Cancellation Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'cancellationFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'WaitingFeeAmount',
			header: 'Waiting Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'waitingFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'TerminalFeeAmount',
			header: 'Terminal Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'terminalFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'TotalFare',
			header: 'Total Fare',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'totalFare',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'PromoDiscount',
			header: 'Promo',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'promoDiscount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'SpecialDiscount',
			header: 'Special Discount',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'specialDiscount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'PromoCode', header: 'Promo-Code', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'promoCode',
			placeholder: 'Type here', active: false
		},
		{
			field: 'NetFare', header: 'Net Fare', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'netFare',
			placeholder: 'Type here', active: false
		},
		{
			field: 'DriverEarnings',
			header: 'Driver Earnings',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'driverEarnings',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'WithholdingTaxAmount',
			header: 'Withholding Tax',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'withholdingTaxAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'XpressEarnings',
			header: 'Xpress Earnings',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'xpressEarnings',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'BoracayConvenienceFeeAmount',
			header: 'Convenience Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'boracayConvenienceFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'ConvenienceScheduledFeeAmount',
			header: 'Scheduled Booking Fee',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'convenienceScheduledFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'OPCFareAmount',
			header: 'OPC Fare',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'OPCFareAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'RevenueStatus',
			header: 'Revenue Status',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'revenueStatus',
			placeholder: 'Type here',
			active: false
		},
	];

	topUps_cashOut_Cols = [
		{
			field: 'TransactionId', header: 'TX ID', width: '20%', fieldType: FieldTypeEnum.InputNumber,
			model: 'transactionId', placeholder: 'Type here', active: false
		},
		{
			field: 'CreatedAtDate',
			header: 'TX Date',
			width: '20%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'createdAtDate',
			placeholder: 'Date',
			active: false
		},
		{
			field: 'CreatedAtTime',
			header: 'TX Time',
			width: '20%',
			fieldType: FieldTypeEnum.CalendarTime,
			model: 'createdAtTime',
			placeholder: 'Time',
			active: false
		},
		{
			field: 'TransactionType',
			header: 'Transaction Type',
			width: '20%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'transactionType',
			options: (this.financeMenu === FinanceMenuEnum.TopUps)
				? this.topUpsTransactionTypes
				: [TransactionTypeEnum.PayOut],
			placeholder: 'Select',
			active: false
		},
		{
			field: 'RiderId', header: 'Driver ID', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
			placeholder: 'Type here', active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'Source', header: 'Source', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'source',
			placeholder: 'Type here'
		},
		{
			field: 'Target', header: 'Target', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'target',
			placeholder: 'Type here'
		},
		{
			field: 'XpressUserWalletOperationType',
			header: 'Description',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'xpressUserWalletOperationType',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'Amount', header: 'Amount', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'amount',
			placeholder: 'Type here', active: false
		},
		{
			field: 'XenditFeeAmount',
			header: (this.financeMenu === FinanceMenuEnum.TopUps) ? 'MSC' : 'Xendit Service Charge',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'xenditFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'XenditVatAmount',
			header: 'VAT',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'xenditVatAmount',
			placeholder: 'Type here',
			active: false
		},
	];

	customerXpayWalletCols = [
		{
			field: 'CreatedAtDate',
			header: 'TX Date',
			width: '20%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'createdAtDate',
			placeholder: 'Date'
		},
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		}
	];

	driverWalletCols = [
		{
			field: 'BookingId', header: 'Booking Id', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'bookingid',
			placeholder: 'Type here', active: false
		},
		{
			field: 'TransactionId',
			header: 'TX ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'transactionId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CreatedAtDate',
			header: 'TX Date',
			width: '20%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'createdAtDate',
			placeholder: 'Date'
		},
		{
			field: 'RiderId', header: 'Driver ID', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
			placeholder: 'Type here', active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		}
	];

	customerWalletSummaryCols = [
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '33%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '33%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'WalletAmount',
			header: 'Wallet Balance (UserWallet)',
			width: '33%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'walletAmount',
			placeholder: 'Type here',
			active: false
		}
	];

	driverWalletSummaryCols = [
		{
			field: 'RiderId',
			header: 'Driver ID',
			width: '33%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'riderId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '33%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'WalletAmount',
			header: 'Total Wallet Balance (Xpress + Cash)',
			width: '33%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'walletAmount',
			placeholder: 'Type here',
			active: false
		}
	];

	walletCommonCols = [
		{
			field: 'TransactionType',
			header: 'TX Details',
			width: '20%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'transactionType',
			options: this.arrayFilterTransactionTypes,
			placeholder: 'Select',
			active: false
		},
		{
			field: 'Source', header: 'Source', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'source',
			options: this.arrayFilterTransactionTypes, placeholder: 'Select'
		},
		{
			field: 'Target', header: 'Target', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'target',
			options: this.arrayFilterTransactionTypes, placeholder: 'Select'
		},
		{
			field: 'DebitAmount',
			header: 'Transaction In',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'debitAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CreditAmount',
			header: 'Transaction Out',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'creditAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'WalletAmount',
			header: 'Balance',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'walletAmount',
			placeholder: 'Type here',
			active: false
		}
	];

	driverCommerceCols = [
		{ field: 'BookingId', header: 'Booking Id', width: '12%', fieldType: FieldTypeEnum.Inputs, model: 'bookingid', placeholder: 'Type here', active: false },
		{ field: 'TransactionId', header: 'TX ID', width: '10%', fieldType: FieldTypeEnum.InputNumber, model: 'transactionId', placeholder: 'Type here', active: false },
		{ field: 'CreatedAtDate', header: 'TX Date', width: '10%', fieldType: FieldTypeEnum.Calendar, model: 'createdAtDate', placeholder: 'Date' },
		{ field: 'CreatedAtTime', header: 'TX Time', width: '8%', fieldType: FieldTypeEnum.Inputs, model: 'createdAtTime', placeholder: 'Time', active: false },
		{
			field: 'RiderId',
			header: 'Driver ID',
			width: '10%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'riderId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '10%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		...this.walletCommonCols
	];

	customerCommerceCols = [
		{ field: 'CreatedAtDate', header: 'TX Date', width: '10%', fieldType: FieldTypeEnum.Calendar, model: 'createdAtDate', placeholder: 'Date' },
		{ field: 'CreatedAtTime', header: 'TX Time', width: '8%', fieldType: FieldTypeEnum.Inputs, model: 'createdAtTime', placeholder: 'Time', active: false },
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '10%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerNameCapitalized',
			header: 'Customer Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'RiderId',
			header: 'Driver ID',
			width: '10%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'riderId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'RiderNameCapitalized',
			header: 'Driver Name',
			width: '12%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'riderName',
			placeholder: 'Type here',
			active: false
		},
		{ field: 'BookingId', header: 'Booking Id', width: '12%', fieldType: FieldTypeEnum.Inputs, model: 'bookingid', placeholder: 'Type here', active: false },
		...this.walletCommonCols
	];

	lguAdminCommonCols = [
		{
			field: 'TransactionType',
			header: 'TX Details',
			width: '20%',
			fieldType: FieldTypeEnum.Dropdown,
			model: 'transactionType',
			options: this.arrayFilterTransactionTypes,
			placeholder: 'Select',
			active: false
		},
		{
			field: 'Source', header: 'Source', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'source',
			options: this.arrayFilterTransactionTypes, placeholder: 'Select'
		},
		{
			field: 'Target', header: 'Target', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'target',
			options: this.arrayFilterTransactionTypes, placeholder: 'Select'
		}
	];

	xenditCommonCols = [
		{
			field: 'BookingId', header: 'Booking Id', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'bookingid',
			placeholder: 'Type here', active: false
		},
		{
			field: 'TransactionId',
			header: 'TX ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'transactionId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CreatedAtDate',
			header: 'TX Date',
			width: '20%',
			fieldType: FieldTypeEnum.Calendar,
			model: 'createdAtDate',
			placeholder: 'Date',
			active: false
		},
		{
			field: 'CreatedAtTime',
			header: 'TX Time',
			width: '20%',
			fieldType: FieldTypeEnum.CalendarTime,
			model: 'createdAtTime',
			placeholder: 'Time',
			active: false
		},
		{
			field: 'RiderId', header: 'Driver ID', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
			placeholder: 'Type here', active: false
		},
		{
			field: 'CustomerId',
			header: 'Customer ID',
			width: '20%',
			fieldType: FieldTypeEnum.InputNumber,
			model: 'customerId',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'CustomerName',
			header: 'Customer Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'customerName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'MerchantName',
			header: 'Merchant Name',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'merchantName',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'Amount', header: 'Amount', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'amount',
			placeholder: 'Type here', active: false
		}
	];

	xenditCollectionCols = [
		{
			field: 'XenditFeeAmount',
			header: 'MSC',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'xenditFeeAmount',
			placeholder: 'Type here',
			active: false
		},
		{
			field: 'XenditVatAmount',
			header: 'VAT',
			width: '20%',
			fieldType: FieldTypeEnum.Inputs,
			model: 'xenditVatAmount',
			placeholder: 'Type here',
			active: false
		},
	];

	// Grid settings
	rowsPerPage: number = 13;
	totalRecords: number = -1;
	exportHeaderColumns: string[] = [];
	exportDataColumns: string[] = [];

	fieldTypeEnum = FieldTypeEnum;
	homeTransactionItems: HomeTransactions = new HomeTransactions();
	txnHeaderSearch: any = {
		transactionId: null,
		createdAtDate: null,
		createdAtTime: null,
		riderId: null,
		driverTags: null,
		riderName: null,
		customerId: null,
		customerName: null,
		vehicleType: null,
		transactionType: null,
		debitAmount: null,
		creditAmount: null,
		walletAmount: null,
		merchantName: null,
		xenditFeeAmount: null,
		xenditVatAmount: null,
		convenienceScheduledFeeAmount: null,
		boracayConvenienceFeeAmount: null,
		withholdingTaxAmount: null,
		amount: null,
		serviceTypeAndVehicleTypeText: null,
		serviceAndVehicleType: null,
		withPromo: null,
		paymentMethod: null,
		payServise: null,
		deliveryOrderId: null,
		status: null,
		waitingFeeAmount: null,
		cancellationFeeAmount: null,
		bookingFeeAmount: null,
		terminalFeeAmount: null,
		revenueStatus: null,
		OPCFareAmount: null,
	};
	first: number = 0;
	sortField: string | string[] = '';
	sortOrder: number = 1;

	loading: boolean = false;
	exportLoading: boolean = false;
	searchTimer: number = 0;
	visibleTransactionsFilter: boolean = false;

	filterObj: any = {
		startDate: null,
		endDate: null,
		digitType: null,
		payService: null
	};

	tableName!: string;
	selectedColumns: any[] = [];
	breadcrumbs: MenuItem[] = [];
	isLGUAdmin: boolean = false;
	private routedFinanceMenu: FinanceMenuEnum | undefined;

	get financeMenu(): FinanceMenuEnum | undefined {
		return this.routedFinanceMenu;
	}

	isWalletReport(): boolean {
		return this.financeMenu === FinanceMenuEnum.CustomerWallet ||
			this.financeMenu === FinanceMenuEnum.DriverWallet;
	}

	constructor(
		private messageService: MessageService,
		private deliveryOrderService: DeliveryOrderService,
		private paymentTransactionService: XpressPaymentTransactionService,
		public configService: ConfigService,
		public app: AppComponent,
		public appData: AppDataService,
		private userTableSettings: UserTableSettingsService,
		private cdRef: ChangeDetectorRef,
		private route: ActivatedRoute,
		private router: Router) {
		this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
		this.isLGUAdmin = this.appData.hasPermission(MenuPermissionConfig.LGU_ADMIN, MenuPermissionActionEnum.Read);
	}

	ngOnInit(): void {
		const data = this.route.snapshot.data;
		if (data['routeName'] === 'finance' && data['financeMenu'] != null) {
			this.routedFinanceMenu = data['financeMenu'] as FinanceMenuEnum;
			if (!this.menuPermissionActive) {
				this.menuPermissionActive = data['permission'];
			}
		}

		if (this.appData.hasPermission(MenuPermissionConfig.FINANCE_COLLECTION_PENDING, MenuPermissionActionEnum.Read)) {
			this.menuTabItems.push({
				label: 'Pending Collection',
				command: (e: any) => {
					this.assignFinanceMenu(FinanceMenuEnum.CollectionPending);
				}
			});
		}

		this.setReportParams();
	}

	ngAfterViewInit(): void {
		this.cdRef.detectChanges();
	}

	updateBreadcrumbs() {
		this.breadcrumbs = [];
		if (this.routedFinanceMenu != null) {
			this.breadcrumbs.push({icon: 'icon_finance'});
			this.breadcrumbs.push({label: 'Finances'});
			let breadcrumb = '';
			switch (this.menuPermissionActive) {
				case MenuPermissionConfig.FINANCE_REVENUE:
					breadcrumb = 'Revenue';
					break;
				case MenuPermissionConfig.FINANCE_PAYOUT:
					breadcrumb = 'Payout';
					break;
				case MenuPermissionConfig.FINANCE_INVOICES:
					breadcrumb = 'Invoices';
					break;
				case MenuPermissionConfig.FINANCE_GUARANTEEDPAY:
					breadcrumb = 'Guaranteed Pay';
					break;
				case MenuPermissionConfig.FINANCE_TOPUPS:
					breadcrumb = 'Top Ups';
					break;
				case MenuPermissionConfig.FINANCE_CASHOUT:
					breadcrumb = 'Cash Out';
					break;
			}
			this.breadcrumbs.push({label: breadcrumb});
		} else if (this.app.backOfficeRoot) {
			this.breadcrumbs.push({icon: 'icon_back_office'});
			this.breadcrumbs.push({label: 'Application'});
			this.breadcrumbs.push({label: 'Transactions'});
			this.breadcrumbs.push({label: 'Customer'});
		}
	}

	onSelectedColumnsChange(event: any) {
		if (event && event.length > 0) {
			this.selectedColumns = event;
		} else {
			this.selectedColumns = this.cols;
		}

		this.exportHeaderColumns = this.selectedColumns.map(x => x.header);
		this.exportDataColumns = this.selectedColumns.map(x => x.field);
	}

	handleLazyLoad(event: TableLazyLoadEvent): void {
		if (!this.cols.length) {
			return;
		}

		const skip = event.first ? event.first : 0;

		if (event.rows) {
			this.rowsPerPage = event.rows;
		}

		if (!event.sortField) {
			this.sortField = 'TransactionId';
			this.sortOrder = -1; // Desc
		} else {
			this.sortField = event.sortField;
			this.sortOrder = event.sortOrder ? event.sortOrder : 1;
		}
		this.setReportParams();

		if (this.columnSelector) {
			this.columnSelector.loadTableSettings(this.tableName);
		}

		this.callGridTitles(skip);
	}

	filter: {
		searchName: string;
	} = {searchName: ''};

	handleFilterChange(model: string, event: any): void {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}

		this.searchTimer = window.setTimeout(() => {
			if (model === 'TransactionId') {
				this.txnHeaderSearch.transactionId = event;
			}
			this.callGridTitles(0);
			this.searchTimer = 0;
		}, 1500);
	}

	handleHeaderFilterChange() {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}
		this.searchTimer = window.setTimeout(() => {
			this.callGridTitles(0);
			this.searchTimer = 0;
		}, 1500);
	}

	removeDriverTag(transaction: any) {
		//todo
	}

	isRevenueReport() {
		return this.financeMenu === FinanceMenuEnum.Revenue ||
			this.financeMenu === FinanceMenuEnum.TopUps ||
			this.financeMenu === FinanceMenuEnum.CashOut;
	}

	isCollectionReport() {
		return this.financeMenu === FinanceMenuEnum.Collection ||
			this.financeMenu === FinanceMenuEnum.CollectionPending;
	}

	onFinanceCardClick(menu: FinanceMenuEnum) {
		this.assignFinanceMenu(menu);
	}

	assignFinanceMenu(menu: FinanceMenuEnum) {
		if (menu === FinanceMenuEnum.Collection) {
			void this.router.navigate(['/xpressadmin/finance/collection']);
			return;
		}
		if (menu === FinanceMenuEnum.CollectionPending) {
			void this.router.navigate(['/xpressadmin/finance/collection-pending']);
			return;
		}
		this.routedFinanceMenu = menu;
		this.setReportParams();
	}

	setReportParams() {
		switch (this.financeMenu) {
			case FinanceMenuEnum.Revenue:
				this.activeCard = FinanceCardEnum.Booking;
				this.tableDataHeader = 'Bookings';
				this.tableHeader = TransactionsTableHeaders.Revenue;
				this.tableName = EditTableConfig.HOME_TRANSACTIONS;
				this.fileName = 'Revenue-Report-';
				this.cols = this.revenueCols;
				break;
			case FinanceMenuEnum.TopUps:
				this.activeCard = FinanceCardEnum.TopUp;
				this.tableDataHeader = 'TopUp';
				this.tableHeader = TransactionsTableHeaders.TopUps;
				this.tableName = EditTableConfig.TOP_UPS;
				this.fileName = 'Top-Ups-Report-';
				this.cols = this.topUps_cashOut_Cols;
				this.filterObj.transactionTypes = this.topUpsTXtypes;
				break;
			case FinanceMenuEnum.CashOut:
				this.activeCard = FinanceCardEnum.CashOut;
				this.tableDataHeader = 'CashOut';
				this.tableHeader = TransactionsTableHeaders.CashOut;
				this.tableName = EditTableConfig.CASH_OUT;
				this.fileName = 'Cash-Out-Report-';
				this.cols = this.topUps_cashOut_Cols;
				this.filterObj.transactionTypes = [TransactionTypeEnum.PayOut];
				break;
			case FinanceMenuEnum.CustomerWallet:
				this.tableDataHeader = 'User Wallet ';
				this.tableHeader = TransactionsTableHeaders.CustomerXpayWallet;
				this.tableName = EditTableConfig.CUSTOMER_XPAY_WALLET;
				this.fileName = 'Customer-Xpay-Wallet-Report-';
				this.cols = this.customerWalletSummaryCols;
				this.filterButtonVisible = false;
				break;
			case FinanceMenuEnum.DriverWallet:
				this.tableDataHeader = 'Driver Wallet';
				this.tableHeader = TransactionsTableHeaders.DriverWallet;
				this.tableName = EditTableConfig.DRIVER_WALLET_SUMMARY;
				this.fileName = 'Driver-Wallet-Report-';
				this.cols = this.driverWalletSummaryCols;
				this.filterButtonVisible = false;
				break;
			case FinanceMenuEnum.Commerce:
				this.tableDataHeader = 'Commerce';
				this.tableHeader = TransactionsTableHeaders.Commerce;
				this.tableName = EditTableConfig.DRIVER_WALLET;
				this.fileName = 'Driver-Wallet-Report-';
				this.cols = this.driverWalletCols.concat(this.walletCommonCols);
				this.filterButtonVisible = false;
				break;
			case FinanceMenuEnum.DriverCommerce:
				this.tableDataHeader = 'Driver Commerce';
				this.tableHeader = TransactionsTableHeaders.DriverCommerce;
				this.tableName = EditTableConfig.DRIVER_WALLET;
				this.fileName = 'Driver-Commerce-Report-';
				this.cols = this.driverCommerceCols;
				this.filterButtonVisible = true;
				break;
			case FinanceMenuEnum.CustomerCommerce:
				this.tableDataHeader = 'Customer Commerce';
				this.tableHeader = TransactionsTableHeaders.CustomerCommerce;
				this.tableName = EditTableConfig.CUSTOMER_XPAY_WALLET;
				this.fileName = 'Customer-Commerce-Report-';
				this.cols = this.customerCommerceCols;
				this.filterButtonVisible = true;
				break;
			case FinanceMenuEnum.Collection:
				this.activeTabItem = this.menuTabItems[0];
				this.tableDataHeader = 'Collection';
				this.tableHeader = TransactionsTableHeaders.Collection;
				this.tableName = EditTableConfig.FINANCE_COLLECTION;
				this.fileName = 'Collection-Report-';
				this.cols = this.xenditCommonCols.concat(this.xenditCollectionCols);
				break;
			case FinanceMenuEnum.CollectionPending:
				this.activeTabItem = this.menuTabItems[1];
				this.tableDataHeader = 'Pending Collection';
				this.tableHeader = TransactionsTableHeaders.Collection;
				this.tableName = EditTableConfig.FINANCE_COLLECTION_PENDING;
				this.fileName = 'Pending-Collection-Report-';
				this.cols = this.xenditCommonCols;
				break;
		}

		this.defaultCols = this.cols.map(x => x);
	}

	showSidebar() {
		this.showExportSidebar = true;
	}

	exportTransactions() {
		if (!this.exportData.fileType) {
			this.messageService.add({severity: 'error', summary: 'Error', detail: 'Please select file type'});
			return;
		}

		this.exportLoading = true;
		this.deliveryOrderService.exportTransactions(this.getRequestDto(0), this.messageService)
			.then(data => {
				if (!data || !data.Success) {
					this.messageService.add({
						severity: 'error',
						summary: 'Error',
						detail: data?.ErrorMessage || 'Export failed'
					});
					this.exportLoading = false;
					return;
				}
				const fileDownloaded = Utils.saveFileFromBase64Response(data, this.fileName + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'));
				if (fileDownloaded) {
					this.messageService.add({
						severity: 'success',
						summary: 'Success',
						detail: 'Export completed successfully'
					});
				} else {
					this.messageService.add({
						severity: 'warn',
						summary: 'No Data',
						detail: 'No transactions found to export'
					});
				}
				this.exportLoading = false;
			})
			.catch(err => {
				this.exportLoading = false;
				throw err;
			});
	}

	getTransactions(dto: any, homeTransactions: HomeTransactions) {
		this.loading = true;
		let query = new Promise<any>(() => {
		});
		switch (this.financeMenu) {
			case FinanceMenuEnum.Revenue:
				query = this.deliveryOrderService.getTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.GuaranteedPay:
				query = this.deliveryOrderService.getGuaranteedPay(dto, this.messageService);
				break;
			case FinanceMenuEnum.TopUps:
				query = this.deliveryOrderService.getTopUps(dto, this.messageService);
				break;
			case FinanceMenuEnum.CashOut:
				query = this.deliveryOrderService.getCashOut(dto, this.messageService);
				break;
			case FinanceMenuEnum.CustomerWallet:
				query = this.deliveryOrderService.getTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.DriverWallet:
				query = this.deliveryOrderService.getTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.Commerce:
				query = this.deliveryOrderService.getTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.DriverCommerce:
			case FinanceMenuEnum.CustomerCommerce:
				query = this.deliveryOrderService.getTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.Collection:
				query = this.paymentTransactionService.getInOutTransactions(dto, this.messageService);
				break;
			case FinanceMenuEnum.CollectionPending:
				query = this.paymentTransactionService.getInOutTransactions(dto, this.messageService);
				break;
		}

		query.then(data => {
			if (!data.Success) {
				homeTransactions.Loading = false;
				this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
				return;
			}
			this.first = dto.Skip;
			this.totalRecords = data.TotalRecords;
			const transactions = data.Transactions.map((x: any) => {
				x.Amount = Utils.toFixedSafe(x.Amount);
				x.BaseFare = Utils.toFixedSafe(x.BaseFare);
				x.DriverEarnings = Utils.toFixedSafe(x.DriverEarnings);
				x.NetFare = Utils.toFixedSafe(x.NetFare);
				x.TotalFare = Utils.toFixedSafe(x.TotalFare);
				x.WithholdingTaxAmount = Utils.toFixedSafe(x.WithholdingTaxAmount);
				x.XenditFeeAmount = Utils.toFixedSafe(x.XenditFeeAmount);
				x.XenditVatAmount = Utils.toFixedSafe(x.XenditVatAmount);
				x.XpressEarnings = Utils.toFixedSafe(x.XpressEarnings);
				x.Distance = Utils.toFixedSafe(x.Distance);
				x.Time = Utils.toFixedSafe(x.Time);
				x.PromoDiscount = Utils.toFixedSafe(x.PromoDiscount);
				x.SpecialDiscount = Utils.toFixedSafe(x.SpecialDiscount);
				x.Surge = Utils.toFixedSafe(x.Surge);
				x.ConvenienceScheduledFeeAmount = Utils.toFixedSafe(x.ConvenienceScheduledFeeAmount);
				x.BoracayConvenienceFeeAmount = Utils.toFixedSafe(x.BoracayConvenienceFeeAmount);
				x.WaitingFeeAmount = Utils.toFixedSafe(x.WaitingFeeAmount);
				x.CancellationFeeAmount = Utils.toFixedSafe(x.CancellationFeeAmount);
				x.BookingFeeAmount = Utils.toFixedSafe(x.BookingFeeAmount);
				if (this.financeMenu === FinanceMenuEnum.Revenue) {
					x.TerminalFeeAmount = Utils.toFixedSafe(x.TerminalFeeAmount);
				}
				x.OPCFareAmount = Utils.toFixedSafe(x.OPCFareAmount);
				return x;
			});

			homeTransactions.Items.push(...transactions);

			if (this.financeMenu === FinanceMenuEnum.Revenue ||
				this.financeMenu === FinanceMenuEnum.TopUps ||
				this.financeMenu === FinanceMenuEnum.CashOut ||
				this.isWalletReport()) {
				this.setFinanceCardsData(data);
			}

			this.transactions = data.Transactions;

			homeTransactions.Items.forEach(item => {
				if (item.Promo) {
					item.WithPromo = 'Yes';
					item.WithPromoValue = 1;
				} else {
					item.WithPromo = 'No';
					item.WithPromoValue = -1;
				}
				this.mergeDropDownDuplicates(item.PaymentMethod, item.PaymentMethodId, this.arrayFilterPaymentMethodTypes);
			});
			this.loading = false;
		})
			.catch(err => {
				homeTransactions.Loading = false;
				this.loading = false;
				throw err;
			});
		this.mergeDropDownDuplicates('All', 0, this.arrayFilterPaymentMethodTypes);
	}

	mergeDropDownDuplicates(name: string, value: any, array: any[]) {
		if (name) {
			name = name.trim();
			const exists = array.some((obj: any) => obj.name === name);
			if (!exists) {
				array.push({
					name,
					value
				});
			}
		}
	}

	getStatusStyles(status: string): StylesStatus {
		let backgroundColor: string;
		let textColor: string;
		switch (status) {
			case 'Completed':
				backgroundColor = '#E7F7EF';
				textColor = '#1CBA70';
				break;
			case 'Pending':
				backgroundColor = '#FFEFCC';
				textColor = '#FFB100';
				break;
			case 'Cancelled':
				backgroundColor = '#FDEBEA';
				textColor = '#EB4236';
				break;
			default:
				backgroundColor = '';
				textColor = '';
		}

		return {
			backgroundColor,
			color: textColor
		};
	}

	onSelectionChange(event: any) {
		this.selectedTransaction = event?.data;
	}

	handleHideTransactionInfo() {
		this.showDetailTransactionSidebar = false;
	}

	handleShowTransactionInfo(transaction: any) {
		if (this.isLGUAdmin || this.isWalletReport()) {
			return;
		}
		this.selectedTransaction = transaction;
		this.showDetailTransactionSidebar = true;
	}

	callGridTitles(skip: number) {
		this.callTransactions(skip);
	}

	getRequestDto(skip: number) {
		const dto = {
			SearchName: this.filter.searchName,
			TransactionId: this.txnHeaderSearch.transactionId ? this.txnHeaderSearch.transactionId : null,
			CreatedAtDate: this.txnHeaderSearch.createdAtDate ? moment(this.txnHeaderSearch.createdAtDate).format('YYYY-MM-DDTHH:mm:ss') : null,
			CreatedAtTime: this.txnHeaderSearch.createdAtTime ? moment(this.txnHeaderSearch.createdAtTime).format('YYYY-MM-DDTHH:mm:ss') : null,
			RiderId: this.txnHeaderSearch.riderId ? this.txnHeaderSearch.riderId : null,
			DriverTags: this.txnHeaderSearch.driverTags ? this.txnHeaderSearch.driverTags : null,
			TransactionType: this.txnHeaderSearch.transactionType ? this.txnHeaderSearch.transactionType : null,
			DebitAmount: (this.txnHeaderSearch.debitAmount && this.txnHeaderSearch.debitAmount !== '-') ? this.txnHeaderSearch.debitAmount : null,
			CreditAmount: (this.txnHeaderSearch.creditAmount && this.txnHeaderSearch.creditAmount !== '-') ? this.txnHeaderSearch.creditAmount : null,
			WalletAmount: this.txnHeaderSearch.walletAmount ? this.txnHeaderSearch.walletAmount : null,
			RiderName: this.txnHeaderSearch.riderName ? this.txnHeaderSearch.riderName : '',
			CustomerId: this.txnHeaderSearch.customerId ? this.txnHeaderSearch.customerId : null,
			CustomerName: this.txnHeaderSearch.customerName ? this.txnHeaderSearch.customerName : '',
			VehicleType: this.txnHeaderSearch.vehicleType ? this.txnHeaderSearch.vehicleType : null,
			BaseFare: this.txnHeaderSearch.baseFare ? this.txnHeaderSearch.baseFare : null,
			Distance: this.txnHeaderSearch.distance ? this.txnHeaderSearch.distance : null,
			Time: this.txnHeaderSearch.time ? this.txnHeaderSearch.time : null,
			Surge: this.txnHeaderSearch.surge ? this.txnHeaderSearch.surge : null,
			WaitingFeeAmount: this.txnHeaderSearch.waitingFeeAmount ? this.txnHeaderSearch.waitingFeeAmount : null,
			CancellationFeeAmount: this.txnHeaderSearch.cancellationFeeAmount ? this.txnHeaderSearch.cancellationFeeAmount : null,
			BookingFeeAmount: this.txnHeaderSearch.bookingFeeAmount ? this.txnHeaderSearch.bookingFeeAmount : null,
			...(this.financeMenu === FinanceMenuEnum.Revenue
				? {TerminalFeeAmount: this.txnHeaderSearch.terminalFeeAmount ? this.txnHeaderSearch.terminalFeeAmount : null}
				: {}),
			TotalFare: this.txnHeaderSearch.totalFare ? this.txnHeaderSearch.totalFare : null,
			PromoDiscount: this.txnHeaderSearch.promoDiscount ? this.txnHeaderSearch.promoDiscount : null,
			SpecialDiscount: this.txnHeaderSearch.specialDiscount ? this.txnHeaderSearch.specialDiscount : null,
			NetFare: this.txnHeaderSearch.netFare ? this.txnHeaderSearch.netFare : null,
			WithholdingTaxAmount: this.txnHeaderSearch.withholdingTaxAmount ? this.txnHeaderSearch.withholdingTaxAmount : null,
			DriverEarnings: this.txnHeaderSearch.driverEarnings ? this.txnHeaderSearch.driverEarnings : null,
			XpressEarnings: this.txnHeaderSearch.xpressEarnings ? this.txnHeaderSearch.xpressEarnings : null,
			XpressUserWalletOperationType: this.txnHeaderSearch.xpressUserWalletOperationType ? this.txnHeaderSearch.xpressUserWalletOperationType : null,
			Amount: this.txnHeaderSearch.amount ? this.txnHeaderSearch.amount : null,
			MerchantName: this.txnHeaderSearch.merchantName ? this.txnHeaderSearch.merchantName : null,
			IsXenditPending: this.financeMenu === FinanceMenuEnum.CollectionPending,
			XenditFeeAmount: this.txnHeaderSearch.xenditFeeAmount ? this.txnHeaderSearch.xenditFeeAmount : null,
			XenditVatAmount: this.txnHeaderSearch.xenditVatAmount ? this.txnHeaderSearch.xenditVatAmount : null,
			ConvenienceScheduledFeeAmount: this.txnHeaderSearch.convenienceScheduledFeeAmount ? this.txnHeaderSearch.convenienceScheduledFeeAmount : null,
			BoracayConvenienceFeeAmount: this.txnHeaderSearch.boracayConvenienceFeeAmount ? this.txnHeaderSearch.boracayConvenienceFeeAmount : null,
			ReportType: this.financeMenu,
			FileType: this.exportData.fileType,
			OPCFareAmount: this.txnHeaderSearch.OPCFareAmount ? this.txnHeaderSearch.OPCFareAmount : null,
			RevenueStatus: this.txnHeaderSearch.revenueStatus ? this.txnHeaderSearch.revenueStatus : null,
			ClientLocationType: this.appData.getClientLocationType(),
			Filter: {
				StartDate: this.filterObj.startDate ? moment(this.filterObj.startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
				EndDate: this.filterObj.endDate ? moment(this.filterObj.endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
				ServiceType: this.filterObj.serviceType,
				VehicleType: this.filterObj.vehicleType,
				DigitType: this.filterObj.digitType,
				WithPromo: this.filterObj.withPromo,
				PayService: this.filterObj.payService,
				TransactionStatus: this.filterObj.transactionStatus,
				TransactionTypes: this.filterObj.transactionTypes
			},
			TimeZoneOffset: Utils.getTimezoneOffset(),
			Skip: skip,
			Take: this.rowsPerPage,
			SortField: this.sortField,
			SortOrder: this.sortOrder,
			HeaderColumns: this.exportHeaderColumns,
			DataColumns: this.exportDataColumns
		};

		return dto;
	}

	callTransactions(skip: number) {
		this.homeTransactionItems = new HomeTransactions();
		this.getTransactions(this.getRequestDto(skip), this.homeTransactionItems);
	}

	setFinanceCardsData(data: any) {
		if (data.FinanceCard.BookingAmount) {
			this.revenueAmounts.bookingAmount = data.FinanceCard.BookingAmount;
		}
		if (data.FinanceCard.TopUpAmount) {
			this.revenueAmounts.topUpAmount = data.FinanceCard.TopUpAmount;
		}
		if (data.FinanceCard.CashOutAmount) {
			this.revenueAmounts.cashOutAmount = data.FinanceCard.CashOutAmount;
		}
		if (data.FinanceCard.WalletAmount) {
			this.revenueAmounts.walletAmount = data.FinanceCard.WalletAmount;
		}

		if (data.FinanceCard && data.FinanceCard.WalletAmount !== undefined &&
			data.FinanceCard.WalletAmount !== null) {
			this.revenueAmounts.walletAmount = data.FinanceCard.WalletAmount;
		}

		let dateTemplate;
		if (this.filterObj.startDate && this.filterObj.endDate) {
			dateTemplate = moment(this.filterObj.startDate).format('DD-MMM-yy')
				+ ' to ' + moment(this.filterObj.endDate).format('DD-MMM-yy');
		} else if (this.filterObj.startDate) {
			dateTemplate = moment(this.filterObj.startDate).format('DD-MMM-yy');
		} else if (this.filterObj.endDate) {
			dateTemplate = moment(this.filterObj.endDate).format('DD-MMM-yy');
		} else {
			dateTemplate = moment(new Date()).format('DD-MMM-yy');
		}

		this.revenueAmounts.bookingLastUpdate = dateTemplate;
		this.revenueAmounts.topUpLastUpdate = dateTemplate;
		this.revenueAmounts.cashOutLastUpdate = dateTemplate;
		this.revenueAmounts.walletLastUpdate = dateTemplate;
	}

	onChangeHeaderFilterDropDown() {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}

		this.searchTimer = window.setTimeout(() => {
			this.callGridTitles(0);
			this.searchTimer = 0;
		}, 1500);
	}

	openTransactionsFilter() {
		this.visibleTransactionsFilter = !this.visibleTransactionsFilter;
	}

	changedVisibleHomeTransactionsFilterEmit(value: any) {
		this.visibleTransactionsFilter = value;
	}

	updateEventEmit(value: any) {
		this.showDetailTransactionSidebar = false;
		this.callGridTitles(0);
	}

	protected readonly MenuPermissionConfig = MenuPermissionConfig;
	protected readonly FinanceCardEnum = FinanceCardEnum;
	protected readonly FinanceMenuEnum = FinanceMenuEnum;
	protected readonly ExportFileTypeModel = ExportFileTypeModel;
}

class HomeTransactions {
	public Loading: boolean = true;
	public TotalRecords: number = 0;
	public Items: Array<any> = [];
	public Skip: number = 0;
	public Take: number = 10;
	public VisibleBtnLoadMore: boolean = false;
}

class FinanceCardsAmounts {
	public bookingAmount: string = '';
	public topUpAmount: string = '';
	public cashOutAmount: string = '';
	public walletAmount: string = '';
	public bookingLastUpdate: string = '';
	public topUpLastUpdate: string = '';
	public cashOutLastUpdate: string = '';
	public walletLastUpdate: string = '';
}
